import React from 'react';
import JumboThemeHeaderContext from "./JumboThemeHeaderContext";
import {createTheme} from "@mui/material/styles";
import PropTypes from 'prop-types';

const JumboThemeHeader = ({children, init}) => {
    const [headerTheme, setHeaderTheme] = React.useState(init);

    const themeHeaderContextValue = React.useMemo(() => ({
        headerTheme: createTheme(headerTheme),
        setHeaderTheme: setHeaderTheme,
    }), [headerTheme, setHeaderTheme]);

    return (
        <JumboThemeHeaderContext.Provider value={themeHeaderContextValue}>
            {children}
        </JumboThemeHeaderContext.Provider>
    );
};

JumboThemeHeader.propTypes = {
    children: PropTypes.node,
    init: PropTypes.string,
}

export default JumboThemeHeader;